/* Copyright Levelise Ltd 2020 - 2026 */
import { useState, useEffect, useContext } from 'react';
import { Chart } from 'chart.js';
import NavBarContext from '../../contexts/NavBarContext';
import RangePicker from '../RangePicker/index';
import { TIME_FRAMES, routes } from '../../utils/constants';
import { fleetChartIds } from '../../utils/chart';
import './index.css';

const TimeFrames = ({ timeFrames, route }) => {
	const navBarContext = useContext(NavBarContext);
	const [selectedOption, setSelectedOption] = useState(TIME_FRAMES.twenty_four_hours);
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();

	const handleOnClick = (time) => {
		setTimeframe(time);
	};

	const handleOnChange = (e) => {
		setTimeframe(e.target.value);
	};

	const resetZoom = (ids) => {
		const instances = Object.values(Chart.instances).filter((instance) => ids.indexOf(instance.canvas.id) >= 0);
		instances.forEach((ci) => {
			if (ci.getZoomLevel() > 1.0) {
				ci.resetZoom();
			}
		});
	};

	const resetZoomForDifferentDataLength = () => {
		const chartKeys = Object.keys(Chart.instances);
		chartKeys.forEach((chartKey) => {
			for (let i = 0; i < 2; i++) {
				const scale = Chart.instances[chartKey].getInitialScaleBounds();
				const scaleKeys = Object.keys(scale);
				scaleKeys.forEach((key) => {
					Chart.instances[chartKey].zoomScale(key, scale[key]);
				});
			}
		});
	};

	const setTimeframe = (time) => {
		if (time !== navBarContext.selectedTimeFrame) {
			navBarContext.setSelectedTimeFrame(time);
			setSelectedOption(time);
		} else {
			navBarContext.setResetZoom();
			if (route === routes.fleet) {
				resetZoom(fleetChartIds);
			} else if (route.startsWith('facility/')) {
				resetZoomForDifferentDataLength();
			}
		}
	};

	const handleOnDateChange = (start, end) => {
		if (navBarContext.startDate !== start || navBarContext.endDate !== end) {
			navBarContext.setStartDate(start);
			navBarContext.setEndDate(end);
		}
	};

	const renderTimeFrameList = () => {
		if (!timeFrames || timeFrames.length === 0) {
			return null;
		}

		return timeFrames.map((time, idx) => (
			<li
				key={idx}
				className={time === selectedOption ? 'selected-timeframe' : ''}
				onClick={() => handleOnClick(time)}
			>
				{time}
			</li>
		));
	};

	const renderTimeFrameOptions = () => {
		if (!timeFrames || timeFrames.length === 0) {
			return null;
		}
		return timeFrames.map((time, idx) => (
			<option key={idx} value={time}>
				{time}
			</option>
		));
	};

	useEffect(() => {
		navBarContext.setSelectedTimeFrame(selectedOption);

		return () => {
			navBarContext.setSelectedTimeFrame(TIME_FRAMES.twenty_four_hours);
		};
	}, []);

	return (
		<div className="timeframes">
			<ul className="timeframes-list">{renderTimeFrameList()}</ul>
			<div id="select-wrapper">
				<select className="timeframes-options" value={selectedOption} onChange={(e) => handleOnChange(e)}>
					{renderTimeFrameOptions()}
				</select>
			</div>
			{selectedOption === TIME_FRAMES.select && (
				<RangePicker
					handleDateRange={(start, end) => handleOnDateChange(start, end)}
					checked={selectedOption === TIME_FRAMES.select ? false : true}
					setStartDate={(startDate) => setStartDate(startDate)}
					setEndDate={(endDate) => setEndDate(endDate)}
					startDate={startDate}
					endDate={endDate}
				/>
			)}
		</div>
	);
};

export default TimeFrames;
